import React from "react";
import { Link as RLink } from "react-router-dom";

import { useRadar } from "../../context/RadarContext";
import { useSearchParamState } from "../../hooks/use-search-param-state";
import "./link.scss";

type LinkProps = {
  pageName: string;
  style?: React.CSSProperties;
  className?: string;
};

/**
 * Single choke point for every internal link of the application (header,
 * grids, lists, footer, blips). The radar slug is therefore prefixed exactly
 * once, and the active filters (`tags`, `release`) survive navigation.
 */
export const radarHref = (
  slug: string,
  pageName: string,
  params: { tags?: string; release?: string } = {}
) => {
  const query = [
    params.tags ? `tags=${params.tags}` : "",
    params.release ? `release=${params.release}` : "",
  ]
    .filter(Boolean)
    .join("&");

  return `/${slug}/${pageName}.html${query ? `?${query}` : ""}`;
};

function Link({
  pageName,
  children,
  className,
  style = {},
}: React.PropsWithChildren<LinkProps>) {
  const { slug } = useRadar();
  const [searchParamState] = useSearchParamState(undefined, {
    parseOptions: { decode: false },
  });
  const { tags, release } = searchParamState;

  return (
    <RLink
      to={radarHref(slug, pageName, { tags, release })}
      style={style}
      {...{ className }}
    >
      {children}
    </RLink>
  );
}

export default Link;
